import React from "react";
import PropTypes from "prop-types";

const ButtonClose = ({ toggleModal, focusButton }) => {
  return (
    <button
      className="popup__button popup__button--close"
      onClick={toggleModal}
      type="button"
      aria-label="Close popup"
      /* eslint-disable-next-line jsx-a11y/no-autofocus */
      ref={focusButton}
    >
      ×
    </button>
  );
};

ButtonClose.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  focusButton: PropTypes.object.isRequired,
};

export default ButtonClose;
